export default {
  api: {
    model: {
      permissionErrorInfo: 'You are not authorized to perform this action',
    },
  },
  components: {
    fields: {
      colour: {
        select: 'Select a color',
      },
      period: {
        fourth: 'Forth',
      },
    },
    form: {
      actions: {
        editFormBuilderItem: {
          drawingColours: 'Drawing colors',
          drawingColoursInfo: 'Colors available when drawing',
        },
      },
    },
    order: {
      actions: {
        addPayment: {
          saleFinalised: 'Sale is finalized and there is no further action required.',
        },
      },
      elements: {
        selectMulti: {
          selected: '{count} Sales selected',
          order: 'Order',
          pageOf: 'Page {page} of {pages}',
          selectAllResults: 'Select all results',
        },
      },
    },
    panel: {
      panelLayout: {
        moveToCentre: 'Move panel to center',
      },
    },
    pass: {
      edit: {
        details: {
          cancelAppointmentBehaviour: 'Cancel appointment behavior',
          deleteAppointmentBehaviour: 'Delete appointment behavior',
        },
      },
    },
    purchaseOrder: {
      actions: {
        complete: {
          info: `
            Are you ready to finalize this order? <br>
            When you finalize an order, all stock items will be added to inventory and you will no longer be able to edit the order.
          `,
        },
      },
    },
    employee: {
      edit: {
        details: {
          ownerEnabledInfo: 'Owner accounts must remain enabled. Transfer ownership to disable.',
        },
      },
    },
    service: {
      edit: {
        details: {
          colourInfo: 'Color to identify this service in your schedule.',
        },
      },
    },
    stockTake: {
      actions: {
        apply: {
          info: 'Finalize stock take. All stock inventory will be adjusted and you will no longer be able to edit the stock take.',
        },
      },
    },
  },
  pages: {
    account: {
      index: {
        referral: {
          step1: '1. Share your personalized link!',
          step1Info: `
            Simply share your personalized link below with your bestie OR enter their details into the 'Invite your friends' area. We'll get in touch with them and let you know if they sign up!
          `,
        },
      },
    },
    appointmentStatusType: {
      id: {
        colourInfo: 'Color of the status label tag on appointments',
      },
    },
    auth: {
      index: {
        switch: {
          authorise: 'Authorize a new user on this device',
        },
      },
    },
    customPage: {
      id: {
        titleColour: 'Title color',
        titleColourInfo: 'The color used for the main title at the top of the page',
      },
    },
    manage: {
      index: {
        loyaltyProgram: {
          settingsInfo: 'Customize the loyalty program settings',
        },
        productCategories: {
          uncategorised: '({count} Uncategorized Product) | ({count} Uncategorized Products)',
          reorderUncategorised: 'Reorder uncategorized products',
        },
        serviceCategories: {
          uncategorised: '({count} Uncategorized Service) | ({count} Uncategorized Services)',
          reorder: 'Reorder uncategorized services',
        },
      },
    },
    minisite: {
      index: {
        menu: {
          customInfo: 'Customize your minsite menu using the options below',
        },
        minimiseGaps: {
          title: 'Minimize gaps',
          info: 'Enable the Minimize Gaps feature on for all Employees',
          successInfo: 'Saved minisite minimize gaps settings',
        },
      },
    },
    order: {
      index: {
        exportItemisedList: 'Export an itemized list',
      },
    },
    segment: {
      edit: {
        colourInfo: 'Color of the segment label tag on appointments',
      },
    },
  },
  general: {
    colour: 'Color',
  },
  meta: {
    Minimisegaps: 'Minimize gaps',
  },
  minimiseGaps: {
    title: 'Minimize gaps',
  },
  minisite: {
    pages: {
      minimiseGaps: 'Minimize Gaps',
    },
  },
}
